// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.

// You can define here the conversion functions (from string) for the custom varTypes of your solution
// See ../generic/ConversionFromString.js for some examples
export const CUSTOM_VAR_TYPES_FROM_STRING_FUNCTIONS = {
  // myVarType: 'myConversionFromStringFunction'
};
